/* ============================================================
   카테고리 페이지 — v2.5 (2026-05-12)
   sub_groups 진입 시 openSchema에 label/desc 동반 전달 → SchemaView 헤더 본질 회복
   2026-05-13 App.tsx 분리
   ============================================================ */
import { CATEGORY_DEF, SCHEMA_LABELS, SCHEMA_DESC } from '../data'
import { ICONS } from '../icons'

export function CategoryView({
  catName, openHome, openSchema,
}: {
  catName: string
  openHome: () => void
  openSchema: (cat: string, s: string, subGroupLabel?: string, subGroupDesc?: string) => void
}) {
  const cat = CATEGORY_DEF.find(c => c.name === catName)
  if (!cat) return null

  const hasSubGroups = cat.sub_groups && cat.sub_groups.length > 0
  const renderItems = hasSubGroups
    ? cat.sub_groups!.map(sg => ({
        key: sg.key,
        schema_name: sg.target,
        label: sg.label,
        desc: sg.desc,
        target_type: sg.target_type
      }))
    : cat.schemas.map(s => ({
        key: s,
        schema_name: s,
        label: SCHEMA_LABELS[s] || s,
        desc: SCHEMA_DESC[s] || '',
        target_type: 'schema' as const
      }))

  return (
    <div>
      <div className="breadcrumb">
        <a onClick={openHome}>홈</a>
        <span className="sep">/</span>
        <span>{catName}</span>
      </div>
      <div className="page-header">
        <h2>
          {catName}
          <span className="meta-mono">
            {hasSubGroups
              ? `${cat.sub_groups!.length} schemas`
              : `${cat.schemas.length} schemas`}
          </span>
        </h2>
        <div className="desc">→ {cat.desc}</div>
      </div>
      <div className="schema-grid">
        {renderItems.map(item => (
          <div
            key={item.key}
            className="schema-card"
            onClick={() => openSchema(
              catName,
              item.schema_name,
              /* v2.5: sub_groups 정의 카테고리만 label/desc 동반 전달.
                 sub_groups 미정의 카테고리는 undefined → SchemaView가 SCHEMA_LABELS fallback. */
              hasSubGroups ? item.label : undefined,
              hasSubGroups ? item.desc : undefined
            )}
          >
            <div className="top">
              <span className="schema-name" style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                <span style={{
                  color: item.target_type === 'view' ? 'var(--accent-amber)' : 'var(--accent-green)',
                  display: 'inline-flex',
                  alignItems: 'center'
                }}>
                  {item.target_type === 'view' ? ICONS.Eye() : ICONS.Database()}
                </span>
                {item.schema_name}
              </span>
              <span className="schema-count">—</span>
            </div>
            <div className="schema-label">{item.label}</div>
            <div className="schema-desc">{item.desc}</div>
            <div className="schema-meta">
              <span>Phase 2 — 카운트 라이브</span>
              <span>—</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
